import { render, staticRenderFns } from "./Video-Lesson-settings.vue?vue&type=template&id=36c4085c"
import script from "./Video-Lesson-settings.vue?vue&type=script&lang=js"
export * from "./Video-Lesson-settings.vue?vue&type=script&lang=js"
import style0 from "./Video-Lesson-settings.vue?vue&type=style&index=0&id=36c4085c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports